export default "<p>\r\n  nav-responsive works!\r\n</p>\r\n"